import React from "react";

import LocationTile from "./LocationTile";
import PrimaryCareTile from "./PrimaryCareTile";

type PrimaryCareProps = React.ComponentProps<typeof PrimaryCareTile>;
type OtherProps = React.ComponentProps<typeof LocationTile>;

type Props = (PrimaryCareProps & Partial<OtherProps>) | (OtherProps & Partial<PrimaryCareProps>);

const isPrimaryCareProps = (props: PrimaryCareProps | OtherProps): props is PrimaryCareProps =>
  "firstName" in props && typeof props.firstName === "string";

/**
 * A convenience switch utility component that chooses based on the caller's input which tile to render.
 * @param props Must include all required properties for at least one tile. Leaving other properties optional.
 */
const AppointmentTile = (props: Props) => {
  if (isPrimaryCareProps(props)) {
    return (
      <PrimaryCareTile
        time={props.time}
        imageId={props.imageId}
        firstName={props.firstName}
        lastName={props.lastName}
        credential={props.credential}
        locationTimezone={props.locationTimezone}
        street={props.street}
      />
    );
  }
  return (
    <LocationTile
      time={props.time}
      imageId={props.imageId}
      locationTimezone={props.locationTimezone}
      street={props.street}
      city={props.city}
    />
  );
};

export default React.memo(AppointmentTile);
